import { render, staticRenderFns } from "./CreateLandingPage.vue?vue&type=template&id=709210ff&scoped=true&"
import script from "./CreateLandingPage.vue?vue&type=script&lang=js&"
export * from "./CreateLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateLandingPage.vue?vue&type=style&index=0&id=709210ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709210ff",
  null
  
)

export default component.exports